@if (rss.webscrape) {
  <div class="row align-items-baseline">
    <div class="col">
      <h3
        class="mt-4"
        i18n="@@edit-webpage"
        >
        Website bearbeiten
      </h3>
    </div>
    <div class="col-auto text-end">
      <app-skill-id-input
        [value]="this.rss.webscrape.skillId"
        (changed)="this.rss.webscrape.skillId = $event; this.service.updateWebscrapeConfig(this.rss.webscrape)"
      ></app-skill-id-input>
    </div>
    <div class="col-auto text-end pe-0">
      <p-toggleswitch
        [(ngModel)]="this.rss.webscrape.active"
        (ngModelChange)="this.service.updateWebscrapeConfig(this.rss.webscrape)"
      ></p-toggleswitch>
    </div>
  </div>
  <p-divider
    align="left"
    styleClass="mt-4 mb-1"
  >
    <span
      class="text-muted small fw-semibold"
      i18n="@@ki-recognition"
    >KI-Erkennung</span>
  </p-divider>
  <div class="row align-items-center mt-3">
    <div class="col-3">
      <span i18n="@@website-usage-description">Nutzen der Website:</span>
      <app-hint i18n="@@website-usage-hint">
        Bitte erläutere der KI, wofür diese Webseite genutzt werden soll.
      </app-hint>
    </div>
    <div class="col">
      <p-inputgroup>
        <p-inputgroup-addon>
          <i
            class="ri-sparkling-fill text-primary"
            style="font-size: 1.2rem;"
          ></i>
        </p-inputgroup-addon>
        <input
          pInputText
          [(ngModel)]="this.rss.webscrape.description"
          (blur)="this.service.updateWebscrapeConfig(this.rss.webscrape)"
          fluid
          >
      </p-inputgroup>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span i18n="@@functionname">Funktionsname</span>
      <app-hint i18n="@@function-name-hint">
        Bitte wähle für deinen Skill einen sprechenden bzw. aussagekräftigen (Funktions)-Namen.
        Es sind max. <b>30 Zeichen</b> für einen Namen zulässig, sowie ausschließlich folgende Zeichen:
        <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b> und <b>_</b>.
      </app-hint>
    </div>
    <div class="col">
      <app-function-name-suggest
        [descriptionString]="this.rss.webscrape.description"
        (finish)="this.rss.webscrape.name = $event; this.service.updateWebscrapeConfig(this.rss.webscrape)"
        >
        <input
          pInputText
          i18n-placeholder="@@name"
          placeholder="Name"
          maxlength="30"
          [(ngModel)]="this.rss.webscrape.name"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.rss.checkFunctionName(this.rss.webscrape.name) && this.service.updateWebscrapeConfig(this.rss.webscrape)"
          fluid
          >
      </app-function-name-suggest>
    </div>
  </div>
  @if (this.rss.webscrape.distinctPages.length > 0) {
    <h5
      class="mt-4"
      i18n="@@existing-subpages"
    >Vorhandene Unterseiten</h5>
  }
  <p-table
    [value]="this.rss.webscrape.distinctPages"
    [rowHover]="true"
    styleClass="p-datatable-sm"
    >
    <ng-template
      pTemplate="body"
      let-scrapePage
      >
      <tr>
        <td>
          <span>{{ scrapePage }}</span>
          <a
            [href]="scrapePage"
            target="_blank"
            class="ms-1"
            >
            <i class="ri-external-link-line"></i>
          </a>
        </td>
        <td class="text-end">
          <p-button
            severity="danger"
            size="small"
            (onClick)="this.deleteWebscrapePages(this.rss.webscrape, this.rss.webscrapeMap.get(scrapePage)!)"
            >
            <i class="ri-close-large-fill"></i>
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
}